import { axiosWithJWT } from '@/api/axiosWithJWT';

export const getList = async ({ commit }) => {
  const { data } = await axiosWithJWT.get('/api/BookingSourceType/GetList');

  commit('storeSourceTypeList', data);

  return data;
};
